
let b = []
import {
modelView,
config,
appletPublicsType,
getChatStat,
cardView,
setCard,
setImage
} from "../../api/api";
import "./ToneModel.less";
import Selector from 'vux/src/components/selector/index.vue'

import { createRequest } from "../../utils/utils";
export default {
name: "ToneModel",
components: {
Selector,
},
props: {
type: Number,
id: Number,
disabldeChat: Boolean









},
data() {
return {
list: [],
list1: [],
defaultValue: "",
typeValue: "",
oneState: false,
disabldeChatActive: this.disabldeChat,
idCount: this.id,
dastles: []
};
},
mounted() {

console.log('%c⧭', 'color: #731d1d', this.disabldeChat)
this.appletPublicsType();
setTimeout(() => {
if (this.type == 1) {
modelView(this.id).then((res) => {
this.defaultValue = res.data.image.audio_timbre;

console.log('%c⧭', 'color: #1d3f73', res.data.image.audio_timbre)
this.typeValue = res.data.image.chat_type;
let str = JSON.stringify(res.data.audio_timbre_map);
console.log('%c⧭', 'color: #997326', str)
let obj = JSON.parse(str);

console.log('%c⧭', 'color: #cc0088', obj)
let data = [];
data = obj[res.data.image.gender];

console.log('%c⧭', 'color: #735656', data)
data.forEach((item) => {
let num = {
key: item.id,
value: item.name,
};
this.list.push(num);
});

this.oneState = true;
setTimeout(() => {
this.oneState = false;

}, 2000)
});
}
else if (this.type == 2) {
cardView(this.id).then((res) => {
this.defaultValue = res.data.card.chat_audio_timbre?res.data.card.chat_audio_timbre: res.data.card.audio_timbre;

this.typeValue = res.data.card.chat_type;
let data = [];
data = res.data.audio_timbre_map[res.data.card.gender];

console.log('%c⧭', 'color: #735656', data)
data.forEach((item) => {
let num = {
key: item.id,
value: item.name,
};
this.list.push(num);
});
console.log('----------------list ', this.list)
this.oneState = true;
setTimeout(() => {
this.oneState = false;

}, 2000)
});
}
}, 2000)
},
beforeDestroy() { },
methods: {
onChange() { },

appletPublicsType() {
appletPublicsType().then((res) => {
let data = res.data.chat_type;
data.forEach((item) => {
let obj = {
key: item.data,
value: item.name,
};
this.list1.push(obj);
});
console.log("%c⧭", "color: #00b300", res);
});
},
onDefaultEvent(value) {
if (this.oneState) return;
this.$vux.loading.show({
text: "设置中请等待",
});
if (this.type == 1) {
setImage({
image_id: this.id,
audio_timbre: value,
}).then(d => {

}, e => {

}).finally(()=>{
this.$vux.loading.hide();
})
} else {
setCard({
card_id: this.id,
chat_audio_timbre: value,
}).then(d => {

}).finally(()=>{
this.$vux.loading.hide();
})
}
},
onTypeEvent(value) {
if (this.oneState) return;
this.$vux.loading.show({
text: "设置中请等待",
});
if (this.type == 1) {

setImage({
image_id: this.id,
chat_type: value,
}).then(d=>{
this.$vux.loading.hide();
this.$emit("onPatternSetFinish", value)
})

} else {
createRequest(
"post",
"applet/webview/card/setting",
{
card_id: this.id,
chat_type: value,
},
(res) => {
this.$vux.loading.hide();
this.$emit("onPatternSetFinish", value)
},
(err) => { }
);
}
},
},
watch: {
disabldeChat(value) {
this.disabldeChatActive = value;
},
async id(value) {
this.idCount = value
console.log('%c⧭', 'color: #e57373', this.type)

},

},
created() {

},
};



// WEBPACK FOOTER //
// ./src/myComponents/ToneModel/ToneModel.vue